// extracted by mini-css-extract-plugin
export default {"PageTitle":"PageTitle_PageTitle__JrmYF"};